import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, forwardRef } from 'react';
import { I18nextProvider } from 'react-i18next';
import originalI81next from 'i18next';
import { useI18n } from './hook.js';
/* @__NO_SIDE_EFFECTS__ */
export const withI18n = (WrappedComponent) => {
    const ComponentWithI18n = forwardRef(({ currentLanguage, ...props }, ref) => {
        const { i18n, isInitialized } = useI18n(currentLanguage);
        useEffect(() => {
            if (currentLanguage && isInitialized) {
                i18n.changeLanguage(currentLanguage);
            }
        }, [currentLanguage, isInitialized, i18n]);
        if (!isInitialized) {
            if (import.meta.env.NODE_ENV === 'test') {
                return (
                // eslint-disable-next-line i18next/no-literal-string
                _jsx("span", { "data-testid": "service-i18n-not-initialized", children: "Service-i18n is not initialized yet. Please ensure the test waits for the initialization to complete." }));
            }
            return null;
        }
        // This flag is set from `global` i18n instance to prevent transitive
        // dependencies with withI18n to render without locale
        // @ts-expect-error test
        if (originalI81next?.__serviceI18nGlobalInstance) {
            return _jsx(WrappedComponent, { ref: ref, ...props });
        }
        return (_jsx(I18nextProvider, { i18n: i18n, children: _jsx(WrappedComponent, { ref: ref, ...props }) }));
    });
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithI18n.displayName = `withI18n(${displayName})`;
    return ComponentWithI18n;
};
